import React from "react";
import RichText from "./RichText";

const WEEK_LAYOUT = [
  { x: 10, valX: 41, labelX: 41 },
  { x: 82, valX: 113, labelX: 113 },
  { x: 154, valX: 185, labelX: 185 },
  { x: 226, valX: 257, labelX: 257 }
];

const DemandVelocity = ({ velocity }) => {
  if (!velocity) return null;
  const { weeks = [], caption, trendLabel, trendValueDisplay, trendBody } = velocity;
  const trendValue = String(trendValueDisplay || "");
  const trendMatch = trendValue.match(/^([+\-]?\d+(?:\.\d+)?)(.*)$/);
  const trendMain = trendMatch ? trendMatch[1] : trendValue;
  const trendSuffix = trendMatch ? trendMatch[2] : "";

  return (
    <div className="abr-velocity-grid">
      <div>
        <div className="abr-card-title">Demand velocity &middot; new Want-Listings in 85251</div>
        <p className="abr-card-sub">
          Weekly count of fresh agent-submitted Want-Listings. Each bar = 7 days, oldest left.
        </p>
        <svg
          viewBox="0 0 320 70"
          width="100%"
          height="92"
          role="img"
          aria-label={`Weekly Want-Listing count: ${weeks.map((w) => `${w.label} ${w.count}`).join(", ")}`}
        >
          <g transform="translate(8, 4)">
            <line x1="0" y1="50" x2="300" y2="50" stroke="#D1D5DB" strokeWidth="0.5" />
            {weeks.map((w, idx) => {
              const layout = WEEK_LAYOUT[idx] || WEEK_LAYOUT[0];
              const fill = w.accent ? "#2D5F73" : "rgba(42,47,59,0.35)";
              const height = w.height || 24;
              const y = 50 - height;
              return (
                <g key={idx}>
                  <rect x={layout.x} y={y} width="62" height={height} fill={fill} rx="2" />
                  <text
                    x={layout.valX}
                    y={y - 4}
                    className="abr-bar-value"
                    textAnchor="middle"
                    fontSize="10"
                    fill={w.accent ? "#2D5F73" : undefined}
                  >
                    {w.count}
                  </text>
                  <text x={layout.labelX} y="63" className="abr-axis-tick" textAnchor="middle" fontSize="8">
                    {w.label}
                  </text>
                </g>
              );
            })}
          </g>
        </svg>
        <RichText as="p" className="abr-insight-caption" text={caption} />
      </div>
      <div className="abr-trend-card">
        <div className="abr-trend-lbl">{trendLabel}</div>
        <div className="abr-trend-value">
          {trendMain}
          {trendSuffix ? <span className="abr-unit">{trendSuffix}</span> : null}
        </div>
        <p className="abr-trend-body">{trendBody}</p>
      </div>
    </div>
  );
};

export default DemandVelocity;
